import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=18b1210b&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=18b1210b&scoped=true&lang=css"
import style1 from "./detail.vue?vue&type=style&index=1&id=18b1210b&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1210b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b1210b')) {
      api.createRecord('18b1210b', component.options)
    } else {
      api.reload('18b1210b', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=18b1210b&scoped=true", function () {
      api.rerender('18b1210b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/SHEINDailyDeliveryData/components/detail.vue"
export default component.exports